import Navbar from '../components/Home/Navbar'
import Sidebar from '../components/Home/Sidebar'
import React, {useState} from 'react'
import HeroSection from '../components/Home/HeroSection'
import InfoSection from '../components/Home/InfoSection'
import ProblemSection from '../components/Home/ProblemSection'

import { homeObjectOne, homeObjectTwo } from '../components/Home/InfoSection/Data'
import { ContentSectionData, ProblemSectionData } from '../components/Home/ProblemSection/Data'
import HowtoSection from '../components/Home/HowtoSection'
import ContentSection from '../components/Home/ContentSection'
import PreFooter from '../components/Home/PreFooter'
import Footer from '../components/Home/Footer'
import '../App.css'

const Home = () => {
	const [isOpen, setIsOpen] = useState(false)

	const toggle = () => {
		setIsOpen(!isOpen)
	}


	return (
		<>
		 <Sidebar isOpen= {isOpen} toggle={toggle}/>
		 <Navbar toggle={toggle} />
      <HeroSection/>
      <InfoSection {...homeObjectOne}/>
      <ProblemSection {...ProblemSectionData}/>
      <HowtoSection {...homeObjectTwo}/>
      <ContentSection {...ContentSectionData}/>
      <PreFooter />
      <Footer />
		</>
	)
}

export default Home
